console.log("Hello from custom.js — product nav script loaded.");

document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".product-nav-wrapper");

  if (!nav) {
    console.log("❌ product-nav-wrapper not found.");
    return;
  }

  console.log("✅ product-nav-wrapper found:", nav);

  const navOffset = nav.offsetTop;
  console.log("📏 Initial nav offsetTop:", navOffset);

  /* ==============================
     STICKY PRODUCT NAV
  ============================== */


const SCROLL_OFFSET = 220; // header + product nav height

document.querySelectorAll('.product-nav-wrapper a[href^="#"]').forEach(link => {
  link.addEventListener('click', function (e) {
    const id = this.getAttribute('href');
    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();

    const y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      SCROLL_OFFSET;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  });
});


  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY;

    if (scrollY >= navOffset) {
      if (!nav.classList.contains("is-sticky")) {
        nav.classList.add("is-sticky");
        console.log("📌 Sticky ACTIVATED");
      }
    } else {
      if (nav.classList.contains("is-sticky")) {
        nav.classList.remove("is-sticky");
        console.log("📌 Sticky DEACTIVATED");
      }
    }
  });

  
  /* ==============================
     HEADER MENU HOVER BEHAVIOR
  ============================== */

  const menuItems = document.querySelectorAll(
    '.header-menu .menu-list__list-item'
  );

  let closeTimer = null;

  menuItems.forEach(item => {
    const submenu = item.querySelector('.menu-list__submenu');
    if (!submenu) return;

    item.addEventListener('mouseenter', () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      item.classList.add('menu-hover-active');
    });

    item.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        item.classList.remove('menu-hover-active');
      }, 300); // close delay (ms)
    });

    submenu.addEventListener('mouseenter', () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    });

    submenu.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        item.classList.remove('menu-hover-active');
      }, 300);
    });
  });





/* ==============================
   MOBILE NAV TOGGLE
============================== */

const toggleBtn = document.querySelector('.product-nav-toggle');

if (toggleBtn && nav) {
  toggleBtn.addEventListener('click', () => {
    nav.classList.toggle('is-open');
  });
}






});
